<template>
  <div>
    <div class="head">
      <div class="head-left" @click="$router.push('/')">
        <div class="logo"></div>
        <div class="logo-text">宏观经济实时监测预测平台</div>
      </div>
      <div class="mobile-menu-btn mobile-only" @click="toggleMobileNav">
        <i :class="mobileNavOpen ? 'el-icon-close' : 'el-icon-menu'"></i>
      </div>
    </div>
    <nav class="pc-only">
      <router-link to="/">首页</router-link>
      <router-link to="/EconomicForecasting">经济预测</router-link>
      <router-link to="/confidenceMonitoring">信心监测</router-link>
      <router-link to="/riskWarning">风险预警</router-link>
      <router-link to="/policySimulation">政策仿真</router-link>
      <router-link to="/researchTeam">研究团队</router-link>
      <a href="https://dedsl.sysu.edu.cn/" target="_blank" rel="noopener noreferrer">数字经济与数据科学实验室</a>
    </nav>
    <div class="nav-mobile mobile-only" v-show="mobileNavOpen">
      <router-link class="nav-item" to="/" @click.native="closeMobileNav">首页</router-link>
      <router-link class="nav-item" to="/EconomicForecasting" @click.native="closeMobileNav">经济预测</router-link>
      <router-link class="nav-item" to="/confidenceMonitoring" @click.native="closeMobileNav">信心监测</router-link>
      <router-link class="nav-item" to="/riskWarning" @click.native="closeMobileNav">风险预警</router-link>
      <router-link class="nav-item" to="/policySimulation" @click.native="closeMobileNav">政策仿真</router-link>
      <router-link class="nav-item" to="/researchTeam" @click.native="closeMobileNav">研究团队</router-link>
      <a class="nav-item" href="https://dedsl.sysu.edu.cn/" target="_blank" rel="noopener noreferrer" @click="closeMobileNav">数字经济与数据科学实验室</a>
    </div>
    <div class="container-div">
      <router-view />
    </div>
    <div class="foot">
      <div class="foot-brand" @click="$router.push('/')">
        <div class="foot-brand-logo"></div>
        <div class="foot-brand-title">
          <div class="foot-brand-title-line1">中山大学</div>
          <div class="foot-brand-title-line2">宏观经济实时监测预测平台</div>
        </div>
      </div>

      <div class="links-section">
        <div class="links-title">快速链接</div>
        <div class="links-content">
          <div class="link-item">
            <a href="https://www.sysu.edu.cn/" target="_blank">中山大学</a> |
            <a href="https://lingnan.sysu.edu.cn/" target="_blank">岭南学院</a>
          </div>
          <div class="link-item">
            <a href="https://www.sysu.edu.cn/info/5452/36502.htm" target="_blank">中山大学经济与管理学部</a>
          </div>
          <div class="link-item">
            <a href="https://dedsl.sysu.edu.cn/" target="_blank" rel="noopener noreferrer">数字经济与数据科学实验室</a>
          </div>
        </div>
      </div>

      <div class="contact-section">
        <div class="contact-title">联系我们</div>
        <div class="contact-content">
          <div class="address">
            <i class="el-icon-location-outline"></i>广州市海珠区新港西路135号
          </div>
          <div class="phone">
            <i class="el-icon-phone"></i>020-84112319
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'layout_index'
  ,data(){
    return {
      mobileNavOpen: false
    }
  }
  ,methods:{
    toggleMobileNav(){
      this.mobileNavOpen = !this.mobileNavOpen
    },
    closeMobileNav(){
      this.mobileNavOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>
.head {
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100px;
  background: #fff;

  .head-left {
    display: flex;
    align-items: center;
    height: 100px;
    cursor: pointer;

    .logo {
      width: 200px;
      height: 100px;
      background: url('../assets/images/logo.jpg') 100% 100% no-repeat;
      background-size: cover;
    }

    .logo-text {
      font-size: 18px;
      font-weight: 600;
      margin-left: 10px;
      color: #292727;
    }
  }

  .mobile-menu-btn {
    font-size: 24px;
    color: #4b54b6;
    padding: 10px;
    border-radius: 6px;
    cursor: pointer;
    min-width: 44px;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;

    &:active {
      background-color: rgba(75, 84, 182, 0.1);
    }
  }
}

nav {
  position: sticky;
  top: 0;
  z-index: 88;
  height: 54px;
  line-height: 54px;
  padding: 0 20px;
  border-bottom: 1px solid #eee;
  background: #cfe2ff;
}

nav a {
  font-weight: bold;
  color: #4b54b6;
  font-size: 18px;
  margin: 0 10px;
  white-space: nowrap;
}

nav a.router-link-exact-active {
  color: #4b54b6;
}

a:hover {
  color: #4b54b6;
  background: none;
}

.nav-mobile {
  position: sticky;
  top: 0;
  z-index: 88;
  background: #cfe2ff;
  border-bottom: 1px solid #eee;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);

  .nav-item {
    display: block;
    padding: 14px 20px;
    min-height: 48px;
    font-size: 16px;
    font-weight: 600;
    color: #4b54b6;
    border-top: 1px solid rgba(255, 255, 255, 0.6);
    transition: background-color 0.2s;

    &:active {
      background-color: rgba(75, 84, 182, 0.15);
    }
  }
}

.pc-only {
  display: none;
}

.mobile-only {
  display: flex;
}

@media (min-width: 980px) {
  .mobile-only {
    display: none;
  }
}

@media (min-width: 980px) {
  nav.pc-only {
    display: flex;
    align-items: center;
  }
}

.container-div {
  flex: 1;
  min-height: 0;
  width: 100%;
  overflow: auto;
}

.foot {
  height: 180px;
  background: #cfe2ff;
  display: flex;
  color: #003366;
  justify-content: space-between;
  align-items: center;
  padding: 0px 5%;
}

.foot-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  flex: 1;
  justify-content: center;
}

.foot-brand-logo {
  width: 44px;
  height: 44px;
  background: url('../assets/images/foot-logo.png') center center no-repeat;
  background-size: 100%;
}

.foot-brand-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #003366;
  letter-spacing: 1px;
}

.foot-brand-title-line1 {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.25;
}

.foot-brand-title-line2 {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.25;
}

.links-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  padding-left: 24px;
}

.links-title {
  font-size: 20px;
  font-weight: bold;
  color: #003366;
  margin-bottom: 0;
  letter-spacing: 1px;
  min-width: 84px;
  white-space: nowrap;
  line-height: 1.4;
}

.links-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.link-item {
  margin: 4px 0;
  font-size: 15px;
  line-height: 1.6;
}

.link-item a {
  color: #003366;
  text-decoration: none;
  transition: opacity 0.3s;
  padding: 2px 4px;
  border-radius: 4px;

  &:hover {
    opacity: 0.8;
  }
}

.contact-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  padding-left: 24px;
}

.contact-title {
  font-size: 20px;
  font-weight: bold;
  color: #003366;
  margin-bottom: 0;
  letter-spacing: 1px;
  min-width: 84px;
  white-space: nowrap;
  line-height: 1.4;
}

.contact-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.address,
.phone {
  font-size: 15px;
  color: #003366;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-start;
  line-height: 1.6;

  i {
    font-size: 18px;
  }
}

.address {
  margin-bottom: 12px;
  line-height: 1.5;
}

// 平板设备 (768px - 980px)
@media (min-width: 768px) and (max-width: 980px) {
  .head {
    padding: 0 20px;
  }

  .foot {
    padding: 20px 24px;

    .links-title,
    .contact-title {
      font-size: 18px;
    }

    .link-item,
    .address,
    .phone {
      font-size: 15px;
    }
  }
}

// 大屏设备 (>1400px)
@media (min-width: 1400px) {
  .head {
    padding: 0 180px;
  }

  nav {
    padding: 0 180px;
  }

  .foot {
    padding: 32px 180px;
  }
}

@media (max-width: 980px) {
  .head {
    height: 72px;
    padding: 0 12px;

    .head-left {
      height: 72px;

      .logo {
        width: 120px;
        height: 72px;
      }

      .logo-text {
        font-size: 16px;
        margin-left: 8px;
        max-width: calc(100vw - 120px - 44px - 48px);
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .foot {
    height: auto;
    padding: 24px 16px;
    flex-direction: column;
    align-items: center;
    gap: 16px;

    .foot-brand {
      width: 100%;
      justify-content: center;
    }

    .links-section,
    .contact-section {
      width: 100%;
      align-items: center;
      flex-direction: column;
      gap: 10px;
      padding-left: 0;
    }

    .links-section {
      padding-bottom: 14px;
      border-bottom: 1px solid #e0e0e0;
    }

    .links-content,
    .contact-content {
      align-items: center;
      text-align: center;
    }

    .address,
    .phone {
      justify-content: center;
    }

    .address {
      text-align: center;
    }
  }
}
</style>
